import GltfViewer from './GltfViewer';

export default {
    GltfViewer,
};